import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import LeftImage from '../../../images/features/hida/title-left.png';
import RightImage from '../../../images/features/hida/title-right.png';

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'inline-flex',
    flexDirection: 'column',
    marginBottom: (props) => (props.dense ? 0 : theme.spacing(5)),
  },
  primary: {
    fontSize: theme.typography.pxToRem(14),
    fontFamily: `Avenir, ${theme.typography.fontFamily}`,
    fontWeight: 'bold',
  },
  box: {
    position: 'relative',
    padding: theme.spacing(1, 2),
    [theme.breakpoints.up('sm')]: {
      padding: theme.spacing(1, 4),
    },
  },
  children: {
    fontSize: theme.typography.pxToRem(20),
    fontWeight: 'bold',
    [theme.breakpoints.up('sm')]: {
      fontSize: theme.typography.pxToRem(28),
    },
  },
  img: {
    position: 'absolute',
    top: 0,
    width: 'auto',
    height: '100%',
  },
}));

const Title = ({ text, children, dense }) => {
  const classes = useStyles({ dense });

  return (
    <div style={{ textAlign: 'center' }}>
      <div className={classes.root}>
        <Typography color="primary" align="center" className={classes.primary}>
          {text}
        </Typography>
        <div className={classes.box}>
          <Typography align="center" className={classes.children}>
            {children}
          </Typography>
          <img src={LeftImage} className={classes.img} style={{ left: 0 }} />
          <img src={RightImage} className={classes.img} style={{ right: 0 }} />
        </div>
      </div>
    </div>
  );
};

export default Title;
